import { RoleCondition } from "@/components/RoleCondition";
import {
  type SubjectEdit,
  SubjectEditDialog,
} from "@/features/subjects/components/SubjectEditDialog";
import { useAccession } from "./AccessionProvider";
import { AddSampleDialog } from "./detail/SampleSection";
import { useDialogProps } from "./detail/state";
import { AddTestsDialog } from "./dialogs/AddTestsDialog";
import { BillingDialog } from "./dialogs/BillingDialog";
import { CancelDialog } from "./dialogs/CancelDialog";
import { ClearAllResultsDialog } from "./dialogs/ClearAllResultsDialog";
import { CloneDialog } from "./dialogs/CloneDialog";
import { DeleteDialog } from "./dialogs/DeleteDialog";
import { HoldDialog } from "./dialogs/HoldDialog";
import { InstrumentStageDialog } from "./dialogs/InstrumentStageDialog";
import { MoveToSubjectDialog } from "./dialogs/MoveToSubjectDialog";
import { ReceiveDialog, UnreceiveDialog } from "./dialogs/ReceiveDialog";
import { RestoreDialog } from "./dialogs/RestoreDialog";
import { ResultSheet } from "./dialogs/ResultSheet";
import { ResultsDialog } from "./dialogs/ResultsDialog";
import { UpdateAdditionalDialog } from "./dialogs/UpdateAdditionalDialog";
import { UpdateOrgsDialog } from "./dialogs/UpdateOrgsDialog";
import { UpdateResultDialog } from "./dialogs/UpdateResultDialog";
import { UploadDialog } from "./dialogs/UploadDialog";

export function AccessionDialogs() {
  const { accession, samples } = useAccession();
  return (
    <RoleCondition
      roles={["blis_lab_manager", "blis_lab_tech", "blis_lab_assistant"]}
    >
      <ReceiveDialog accession={accession} />
      <UnreceiveDialog accession={accession} />
      <HoldDialog accession={accession} />
      <CloneDialog accession={accession} />
      <InstrumentStageDialog accession={accession} />
      <AccessionSubjectEditDialog accession={accession} />
      <MoveToSubjectDialog accession={accession} />
      <AddTestsDialog accession={accession} />
      <AddSampleDialog accession={accession} />
      <UpdateOrgsDialog accession={accession} />
      <UpdateAdditionalDialog accession={accession} />
      <ResultSheet accession={accession} />
      <CancelDialog accession={accession} />
      <RestoreDialog accession={accession} />
      <UploadDialog accession={accession} />
      <RoleCondition roles={["blis_lab_manager", "blis_lab_tech"]}>
        <ClearAllResultsDialog accession={accession} />
        <ResultsDialog accession={accession} samples={samples} />
        <UpdateResultDialog />
      </RoleCondition>
      <RoleCondition roles={["blis_lab_manager"]}>
        <BillingDialog accession={accession} />
        <DeleteDialog accession={accession} />
      </RoleCondition>
    </RoleCondition>
  );
}

function AccessionSubjectEditDialog({
  accession,
}: {
  accession: { id: number; subject: SubjectEdit };
}) {
  const dialogProps = useDialogProps("editDonor");
  return (
    <SubjectEditDialog
      subject={accession.subject}
      accession={accession}
      {...dialogProps}
    />
  );
}
